import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const SignUp = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "sign-up" */ './hocs')),
});
